/*
 * Site-wide switches.
 *
 * Plain CommonJS, and at the repo root, because it is read from both sides of
 * the build: `gatsby-node.js` runs in Node and `require`s it, and the
 * components `import` it through webpack.
 */

module.exports = {
  /*
   * Contato — the page at /contact/ and everything that leads to it.
   *
   * `false` removes the route entirely (gatsby-node.js deletes the page, so
   * /contact/ is never built and 404s), drops "Contato" from the navbar, and
   * takes out the "Entre em contato →" link at the end of Sobre. Nothing else
   * has to change: those are the only three ways in.
   *
   * The page itself stays in src/pages/contact.js. Flip this to `true` and it
   * is back, form and all — with one caveat: the form is a Netlify Form, and
   * Netlify only registers it by finding `data-netlify="true"` in the built
   * HTML at deploy time. So re-enabling needs a deploy, not just a build,
   * before submissions start arriving again.
   *
   * The footer is deliberately not tied to this. It carries the address,
   * phone, email and WhatsApp, and while the form is off it is the way people
   * get in touch.
   */
  contactEnabled: false,
}
